"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoinTree = void 0;
var JoinTree = /** @class */ (function () {
    function JoinTree(metadataJoins) {
        var _this = this;
        this.generate = function () {
            var roots = _this.findRoots(_this.metadataJoins);
            var joinTrees = _this.buildJoinTrees(roots, _this.metadataJoins);
            return joinTrees;
        };
        this.findRoots = function (joins) {
            var roots = [];
            joins.forEach(function (join) {
                var isRoot = !joins.some(function (parent) { return join.fkTable === parent.pkTable; });
                joins.some(function (parent) {
                    if (join.fkTable === parent.pkTable) {
                        isRoot = false;
                        return true;
                    }
                    return false;
                });
                if (isRoot && !roots.some(function (root) { return root.fkTable == join.fkTable; })) {
                    roots.push(join);
                }
            });
            return roots;
        };
        this.buildJoinTrees = function (roots, joins) {
            var joinTrees = roots.map(function (root) {
                var joinTree = {};
                _this.buildJoinTree(root.fkTable, joins, joinTree);
                return joinTree;
            });
            return joinTrees;
        };
        this.buildJoinTree = function (root, joins, joinTree) {
            joinTree[root] = {};
            joinTree = joinTree[root];
            joins.forEach(function (join) {
                if (root === join.fkTable) {
                    _this.buildJoinTree(join.pkTable, joins, joinTree);
                }
            });
        };
        this.metadataJoins = metadataJoins;
    }
    return JoinTree;
}());
exports.JoinTree = JoinTree;
/**
   * input -> [products, orders, customer_address, order_items] ->
   * pair1 -> [products, orders]
   * pair2 -> [orders, customer_address]
   * pair3 -> [customer_address, order_items]
   *
   [{
       order_items" : {
        "orders" : {
            "customers" : {
                "customer_addresses" : {
                },
            }
            "payments" {

            }
        },
        "products" : {
            "category":{

            }
        }
        }
    }]

order_items -> orders -> customers
reverse
customers -> orders ->  order_items
order_items -> products -> category


order_items -> orders -> customers
reverse
customers -> orders ->  order_items
order_items -> orders -> customers -> customer_address



    output pair1 -> [products, order_items, orders]
    output pair2 -> [orders, customers, customer_address]
    output pair3 -> [customer_address, customers, orders, order_items]
    output -> [customers, order_items, products, orders, customer_address]
  */
//  let userTables = [ "customers","customer_addresses", "customer_addresses1"]
//["products", "customer_addresses", "order_items", "orders"];
//  const trees = [{
//    order_items: {
//      orders: {
//        customers: {
//          customer_addresses: {},
//        },
//         customers1: {
//          customer_addresses1: {},
//        },
//      },
//      products: {
//        categories: {}
//      },
//    },
//  },
//  {
//    "summary": {
//    }
//  }
//  ];
/**
  * --------------------------------------
 [ { from: 'order_items', to: 'orders' },
   { from: 'orders', to: 'customers' },
   { from: 'customers', to: 'customer_addresses' } ]
  */
//# sourceMappingURL=JoinTree.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/abstract_query/JoinTree.js
// module id = 1577
// module chunks = 8